import React, { useEffect, useState } from 'react';
import { LAUNCH_WINDOW_SECONDS } from '../data/eatWellContent';
type CountdownTimerProps = {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function CountdownTimer({
  label,
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(LAUNCH_WINDOW_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(s => s > 0 ? s - 1 : 0), 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: pad(Math.floor(remaining / 3600)),
    unit: 'hrs'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    unit: 'min'
  }, {
    value: pad(remaining % 60),
    unit: 'sec'
  }];
  const digit = size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl';
  return <div className={className} data-id="element-48" data-mp="2zrx62v16xvcj">
      <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-49" data-mp="2zsqiabix5d22">
        {label}
      </p>
      <div className="mt-2 flex items-start justify-center gap-3 sm:gap-4" role="timer" aria-live="off" data-id="element-50" data-mp="1bz3too3vnwra">
        {units.map(({
        value,
        unit
      }, i) => <React.Fragment key={unit} data-id="element-51" data-mp="123kb13ebqukh" data-mpi={i}>
            {i > 0 && <span className={`font-display font-semibold leading-none text-charcoal-500 ${digit}`} aria-hidden="true" data-id="element-52" data-mp="171c1ru38gan3">
                :
              </span>}
            <span className="text-center" data-id="element-53" data-mp="1zqj12vaih49e">
              <span className={`block font-display font-semibold leading-none text-ivory-50 ${digit}`} data-id="element-54" data-mp="1zphr6u58ent9">
                {value}
              </span>
              <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.2em] text-muted" data-id="element-55" data-mp="1pyveb7owgbe9">
                {unit}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}